import * as yup from "yup";
import { emailField } from "./validationFields";

export const InitialValues = {
  email: "",
};

export const Validation = yup.object().shape({
  email: emailField.required("Please enter an email"),
});
